import React from 'react'
const ErrorPage = () => <div>Not found</div>

export default ErrorPage
